import type { StudentProfileContract } from "@chams-pay/contracts";

export type StudentAcademicYear = NonNullable<StudentProfileContract["academicYears"]>[number];

export interface StudentObligationYears {
  readonly historicalYears: readonly StudentAcademicYear[];
  readonly showCurrentYear: boolean;
  readonly showAdvanceYear: boolean;
  readonly allPaidAfterGraduation: boolean;
}

export function nextOpenScheduleYear(current: string | null, clicked: string): string | null {
  return current === clicked ? null : clicked;
}

export function studentObligationYears(student: StudentProfileContract): StudentObligationYears {
  const years = student.academicYears ?? [];
  if (student.lifecycleStatus !== "graduated")
    return {
      historicalYears: years
        .filter((year) => year.role === "historical")
        .sort((left, right) => right.academicYear.localeCompare(left.academicYear)),
      showCurrentYear: true,
      showAdvanceYear: Boolean(student.advanceYear),
      allPaidAfterGraduation: false,
    };

  const unpaidCalendars = new Set(
    student.obligations
      .filter((obligation) => BigInt(obligation.remainingMad) > 0n)
      .map((obligation) => obligation.calendarSnapshotId),
  );
  const historicalYears = years
    .filter((year) => unpaidCalendars.has(year.calendarSnapshotId))
    .map((year) => ({ ...year, role: "historical" as const }))
    .sort((left, right) => right.academicYear.localeCompare(left.academicYear));

  return {
    historicalYears,
    showCurrentYear: false,
    showAdvanceYear: false,
    allPaidAfterGraduation: historicalYears.length === 0,
  };
}
